import { v4 as uuidv4 } from "uuid"

export default function generateRandomKey(): string {
    return uuidv4()
}
